const pubConfs = {
	OK: { includes: ['确定', '确认', 'OK',], icon: 'check' },
	DETAIL: { includes: ['详情'], icon: 'info' },
	SAVE: { includes: ['保存', 'SAVE'], icon: 'save' },
	DELETE: { includes: ['删除', 'DELETE'], icon: 'trash-o', ui: 'action decline alt' },
	CLOSE: { includes: ['取消', 'CANCEL', '关闭', 'CLOSE',], icon: 'close' },
	RESET: { includes: ['重置', 'RESET'], icon: 'undo' },
	ADD: { includes: ['新增', 'NEW', '添加', 'ADD'], icon: 'plus' },
	COMMIT: { includes: ['提交', 'COMMIT'], icon: 'share' },
	PUBLISH: { includes: ['发布', 'PUBLISH'], icon: 'share' },
	FINISH: { includes: ['完成', 'FINISH'], icon: 'share' },
	RETURN: { includes: ['退回', '驳回', '异议', 'RETURN'], icon: 'reply', ui: 'action decline alt' },
	EDIT: { includes: ['修改', 'MODIFY', '编辑', 'EDIT', '录入', '编制'], icon: 'edit' },
	COPY: { includes: ['复制', '拷贝', 'COPY'], icon: 'copy' },
	PASTE: { includes: ['粘贴', 'PASTE'], icon: 'paste' },
	PASS: { includes: ['通过', 'PASS'], ends: ['通过', 'PASS'], icon: 'share' },
	SEARCH: { includes: ['查询', 'SEARCH'], icon: 'search' },
	HELP: { includes: ['帮助', 'HELP'], ui: ' ', props: { shadow: false, right: '10' } },
	AGREE: { includes: ['同意', 'AGREE'], icon: 'check' },
	DISAGREE: { includes: ['不同意', 'DISAGREE'], icon: 'close', ui: 'action decline alt' },
	FORWARD: { includes: ['转发', 'FORWARD'], icon: 'share' },
	HASPROBLEM: { includes: ['有问题', 'HASPROBLEM'], icon: 'reply', ui: 'action decline alt' },
	PRINT: { includes: ['打印', 'PRINT'], icon: 'print' },
	PAUSE: { includes: ['暂停', 'PAUSE'], icon: 'pause', ui: 'action decline alt' },
	STOP: { includes: ['中止', 'STOP'], icon: 'stop', ui: 'action decline alt' },
	GLOBE: { includes: ['翻译', 'GLOBE'], icon: 'globe' },
	REFRESH: { includes: ['刷新', 'REFRESH'], icon: 'refresh' },
	PREVIEW: { includes: ['预览', 'PREVIEW'], icon: 'file-pdf-o' },
	APPLY: { includes: ['申请', 'APPLY', '登记', 'REGISTER', '展开', 'OPEN'], icon: 'plus' },
	CHECK: { includes: ['查看', 'CHECK'], icon: 'eye' },
	SELECTALL: { includes: ['全选', 'SELECTALL'], icon: 'check' },
	UNSELECTALL: { includes: ['全不选', 'UNSELECTALL'], icon: 'close' },
	IMPORT: { includes: ['导入', 'IMPORT'], icon: 'share' },
	IMPORT: { includes: ['导出', 'EXPORT'], icon: 'download' },
	SHRINK: { includes: ['收缩', 'SHRINK'], icon: 'minus' },
}

export default pubConfs